import React, { useEffect, useState } from 'react';
import AppLayout from '../Layouts/AppLayout';
import { Button } from '@/components/ui/button';
import Field from '../Fields/Field';
import { createUser, changePassword } from '../../services/authService';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAlert } from '../../hooks/useAlert';
import { useGoBackSimple } from '../../hooks/useGoBack';

const RegistroComponent = () => {
  const goBack = useGoBackSimple();
  const { state } = useLocation();
  const isUpdate = !!state;
  const { errorAlert, successAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(state?.user || {
    email: '',
    name: '',
    password: '',
    password_confirmation: '',
    role: 'tramitadora'
  });

  const handleChange = ({ name, value }) => {
    setData({
      ...data,
      [name]: value
    });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (isUpdate) {
      changePassword({ user: data })
        .then(res => {
          goBack();
          successAlert({ message: 'Usuario actualizado con éxito' });
        }).catch(err => {
          errorAlert({
            title: 'Error al actualizar usuario',
            exception: err
          });
        }).finally(() => {
          setLoading(false);
        });
    } else {
      createUser({ user: data })
        .then(res => {
          goBack();
          successAlert({ message: 'Usuario creado con éxito' });
        }).catch(err => {
          errorAlert({
            title: 'Error al crear usuario',
            exception: err
          });
        }).finally(() => {
          setLoading(false);
        });
    }

  }



  return (
    <AppLayout title="Registro de usuario">
      <div className="bg-white p-4 max-w-md mx-auto shadow-md rounded-md">
        <form method="POST" onSubmit={handleSubmit} >
          <div className="my-2">
            <Field
              type="text"
              name="name"
              label="Nombre:"
              value={data.name}
              onChange={handleChange}
              disabled={isUpdate}
            />
          </div>
          <div className="my-2">
            <Field
              type="email"
              name="email"
              label="E-mail:"
              value={data.email}
              onChange={handleChange}
              disabled={isUpdate}
            />
          </div>
          <div className="my-2">
            <Field
              type="password"
              name="password"
              label="Contraseña:"
              value={data.password}
              onChange={handleChange}
            />
          </div>
          <div className="my-2">
            <Field
              type="password"
              name="password_confirmation"
              label="Confirmar contraseña:"
              value={data.password_confirmation}
              onChange={handleChange}
            />
          </div>
          <div className="flex gap-2">
            <Button type="submit" loading={loading}>Guardar</Button>
            <Button
              type="button"
              variant="outline"
              onClick={goBack}
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </AppLayout>
  );
}

export default RegistroComponent;